import { createContext, useState, useMemo} from "react";

// Create context
export const ApiContext = createContext();

export const ApiProvider = ({ children }) => {
    const [benchmarkData, setBenchmarkData] = useState([]);
    const [filterData, setFilterData] = useState([]);  
    const [densityData, setDensityData] = useState([]);
    const [performanceData, setPerformanceData] = useState([]); // Fixed typo
    const [leftdemographicsData, setLeftDemographicsData] = useState([]);
    const [rightdemographicsData, setRightDemographicsData] = useState([]);
    const [IQOSData,setIQOsData] = useState([]);
    const [locationData, setLocationData] = useState([]);
    const [regionData, setRegionData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [tempGeojsonData,setTempGeojsonData] = useState([]);

    const contextValue = useMemo(() => ({
        benchmarkData,
        filterData,
        densityData,
        performanceData,
        leftdemographicsData,
        rightdemographicsData,
        IQOSData,
        locationData,
        regionData,
        districtData,
        tempGeojsonData
    }), [benchmarkData,filterData,densityData,performanceData,leftdemographicsData,rightdemographicsData,IQOSData,locationData,regionData,districtData,tempGeojsonData]);

    const contextActions = useMemo(() => ({
        setBenchmarkData,
        setFilterData,
        setDensityData,
        setPerformanceData,
        setLeftDemographicsData,
        setRightDemographicsData,
        setIQOsData,
        setLocationData,
        setRegionData,
        setDistrictData,
        setTempGeojsonData
    }), []);

    return (
        <ApiContext.Provider value={{ ...contextValue, ...contextActions }}>
            {children}
        </ApiContext.Provider>
    );
};